import BrandTile from "./brandTile";
import {TrackingAction, TrackingFeature, TrackingFeatureLabels, TrackingFeatureStatus} from "../types";

export default class TrackingService {

    private global: OttoGlobal;

    constructor() {
        /*                                    */
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            /*                                                         */
            /*         */
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        console.log("Tracking not available.");
                    }
                }
            }
        }

        /*                                    */
        if (!window.o_util) {
            window.o_util = {
                /*                                                         */
                /*         */
                misc: {
                    getPagecluster: () => {
                        if (window.o_global.debug.status().activated) {
                            console.log("Tracking not available.");
                        }
                        return null
                    }
                }
            }
        }
    }

    sendLoadedTracking(featureOrder: number, featureIndex: number, featureId: string, promoType: string, brandTiles: BrandTile[], masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures = [
            this.createBrandShoppromoFeature(featureOrder, featureIndex,featureId, brandTiles.length, "loaded", promoType, masFeatureTrackingLabels),
            ...brandTiles.map(((brandTile) => {
                return this.createBrandShoppromoTileFeature(brandTile, featureId, "loaded", promoType)
            }))
        ];
        this.global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingFeatures);
    }

    sendScrollTrackingEvent(promoType: string, featureIndex: number,featureId: string, tilePositions: number[]) {
        const parentFeature = {'featureId': this.getParentFeatureTrackingId(promoType, featureId)}
        const tileFeatures = tilePositions.map(position => {
            return {'featureId': this.getTileFeatureTrackingId(promoType, featureId, position)}
        })
        this.global.eventQBus.emit('tracking.bct.submitMiniActions', [parentFeature, ...tileFeatures]);
    }

    sendClickTrackingEvent(featureOrder: number, featureIndex: number, featureId: string, brandTile: BrandTile, filledSlots: number, promoType: string, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures = [
            this.createBrandShoppromoFeature(featureOrder, featureIndex, featureId, filledSlots, "clicked", promoType, masFeatureTrackingLabels),
            this.createBrandShoppromoTileFeature(brandTile, featureId, "clicked", promoType)
        ]
        const trackingAction: TrackingAction = {
            name: "click",
            features: trackingFeatures
        }
        const wkTrackingData = {
            "wk.promo_AttributionFeature": `${promoType}_${window.o_util.misc.getPagecluster()}`,
            "wk.promo_AttributionSource": "manual"
        }

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', wkTrackingData, trackingAction);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": promoType});
    }

    private createBrandShoppromoFeature(featureOrder: number, featureIndex: number, featureId: string, filledSlots: number, status: TrackingFeatureStatus, promoType: string, masFeatureTrackingLabels: TrackingFeatureLabels): TrackingFeature {
        const labels = {
            promo_Feature: ["true"],
            promo_FilledSlots: [(filledSlots).toString()],
            promo_FeatureNumber: [(featureIndex + 1).toString()]
        };
        const mergedLabels = {
            ...labels,
            ...masFeatureTrackingLabels
        }
        return {
            id: this.getParentFeatureTrackingId(promoType, featureId),
            name: promoType,
            position: featureOrder,
            status: status,
            labels: mergedLabels
        }
    }

    private createBrandShoppromoTileFeature(brandTile: BrandTile, featureId: string, status: TrackingFeatureStatus, promoType: string): TrackingFeature {
        return {
            id: this.getTileFeatureTrackingId(promoType, featureId, brandTile.position),
            parentId: this.getParentFeatureTrackingId(promoType, featureId),
            name: promoType + "-Tile",
            position: brandTile.position,
            status: status,
            labels: {
                promo_Content: [brandTile.urlPath],
                promo_TargetPsr: [brandTile.dreson],
                promo_Source: ["manual"],
                promo_ImageId: [brandTile.imageId]
            }
        };
    }

    private getParentFeatureTrackingId(promoType: string, featureId: string) {
        return `ft3_bspr${this.getIdSuffix(promoType)}_${featureId}`;
    }

    private getTileFeatureTrackingId(promoType: string, featureId: string, tilePosition: number) {
        return `ft3_bspr${this.getIdSuffix(promoType)}_${featureId}_tile${tilePosition}`;
    }

    getIdSuffix(promoType: string) {
        return (promoType === "BrandShopPromotionLarge") ? "la" : "sm";
    }
}
